var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-config"},[_c('div',{staticClass:"label-config-head mr10"},[_c('h2',[_vm._v("漫画名称："+_vm._s(_vm.comicName))]),_c('h2',[_vm._v("漫画ID："+_vm._s(_vm.comicId))])]),_c('labelAE')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }